import { render } from "./UserRoleSelect.vue?vue&type=template&id=af376292&ts=true"
import script from "./UserRoleSelect.vue?vue&type=script&lang=ts"
export * from "./UserRoleSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__